<!--新增党建引领-->
<template>
    <div class="app-container">
        <div class="x-nav">
            <el-breadcrumb :separator="'＞'">
                <el-breadcrumb-item @click="backList"><a>党建引领</a></el-breadcrumb-item>
                <el-breadcrumb-item>详情</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <el-card shadow="never" style="height: calc(100vh - 140px);overflow: auto;">
            <div class="dj-container">
                <div class="dj-content" v-html="form.content">
                </div>
            </div>
        </el-card>

    </div>
</template>

<script>
import TEditor from '@/components/TEditor.vue';
import { serviceUrl } from "@/utils/global"
import {infoDangj} from "@/api/admin/dangj"

export default {
    name: "dangjDetail",
    components: {
        TEditor
    },
    data() {
        return {
            serviceUrl,
            // 遮罩层
            loading: true,
            dangjId:'',
            categoryList:[],
            subcategoryList:[],
            // 表单参数
            form: {
                title: '',
                content:'',
                appContent:'',
                category:'',
                subcategory:'',
                releaseTime:'',
            },
            rules:{
                title: [{ required: true, message: "请输入标题", trigger: "blur" },],
                content: [{ required: true, message: "请输入内容", trigger: "blur" },],
                category: [{ required: true, message: "请选择党建类别", trigger: "change" },],
                subcategory: [{ required: true, message: "请选择党建子类别", trigger: "change" },],
                releaseTime: [{ required: true, message: "请选择发布时间", trigger: "blur" },],
            },
        };
    },
    created() {

    },
    mounted() {
        if (this.$route.query.dangjId) {
            this.dangjId = this.$route.query.dangjId
            this.queryDangjInfo()
        }
    },
    computed: {},
    methods: {
        queryDangjInfo(){
            infoDangj({ dangjId: this.dangjId }).then(res => {
                if (res.data.code === 1) {
                    this.form = res.data.data;
                }else {
                    this.$message.error("操作失败")
                }
            })
        },
        backList(){
            this.$router.push({
                path: "/dangj",
            });
        },
    }
}
</script>

<style scoped>
.dj-container{
    width: 100%;
    height: auto;
    background-color: #fff;
}
.dj-content{
    width: 96%;
    margin: auto;
    overflow-x: hidden;
}
</style>